var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "policy-layout", attrs: { fluid: "" } },
    [
      _c(
        "div",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-center align-center mt-6" },
                  [
                    _c(
                      "v-avatar",
                      { attrs: { tile: "", width: "160", height: "auto" } },
                      [
                        _c("v-img", {
                          attrs: {
                            contain: "",
                            src: require("@/assets/logo.svg"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-center align-center mt-2" },
                  [_c("router-view", { key: _vm.$route.fullPath })],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "policy-layout-footer" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [_c("client-footer-component")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }